import Client from "@/http/client";
import {
  SupportIssueDto,
  SupportIssueListDto,
  SupportNoticeDto,
  SupportNoticeListDto,
} from "@/http/dto/supportContent";

export class SupportContent {
  static async getIssues(params: {
    page: number;
    take: number;
    periodDays: number;
    keyword?: string;
    hotelObjectId?: string;
    category?: string;
    status?: number;
  }) {
    return await Client.get<SupportIssueListDto>("/v2/supporter/content/issues", params);
  }

  static async getIssue(issueObjectId: string) {
    return await Client.get<SupportIssueDto>(
      `/v2/supporter/content/issues/${issueObjectId}`,
    );
  }

  static async getNotices(params: {
    page: number;
    take: number;
    periodDays: number;
    keyword?: string;
    hotelObjectId?: string;
    category?: string;
  }) {
    return await Client.get<SupportNoticeListDto>("/v2/supporter/content/notices", params);
  }

  static async getNotice(noticeObjectId: string) {
    return await Client.get<SupportNoticeDto>(
      `/v2/supporter/content/notices/${noticeObjectId}`,
    );
  }
}
